import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { OpsappService } from '../../services/opsapp.service';
import { first } from 'rxjs';

@Component({
  selector: 'app-instrument-list',
  templateUrl: './instrument-list.component.html',
  styleUrls: ['./instrument-list.component.css']
})
export class InstrumentListComponent {
  category: any;

  constructor(private opsappService: OpsappService, 
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService){
  }

  ngOnInit(){
    this.loadData();
  }

  loadData(){
    this.opsappService.activeInstrumentCategory.pipe(first()).subscribe(data => {
      if (data == undefined || data == null)
        this.goToCategories();
      else
      {
        console.log(data);
        this.category = data;
      }
    });
  }

  goToCategories(){
    this.router.navigate(["instrument-categories"], { relativeTo: this.route.parent });
  }

  openInstrumentDetail(instrument: any){
    this.opsappService.activeInstrument.next(instrument);
    this.router.navigate(["instrument-service"], { relativeTo: this.route.parent })
  }
}
